import React from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const Logs = () => {
  const logs = [
    { id: 1, type: 'info', message: 'User registered: john@example.com', time: '2025-01-08 14:30:25' },
    { id: 2, type: 'success', message: 'Payment processed: $29.00 from user #123', time: '2025-01-08 14:25:10' },
    { id: 3, type: 'warning', message: 'High API usage detected for AI Model: Deepseek', time: '2025-01-08 14:20:05' },
    { id: 4, type: 'error', message: 'Failed login attempt from IP: 192.168.1.100', time: '2025-01-08 14:15:00' },
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="System Logs" />
        <div className="flex-1 overflow-y-auto p-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <select className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                  <option>All Logs</option>
                  <option>Info</option>
                  <option>Success</option>
                  <option>Warning</option>
                  <option>Error</option>
                </select>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition">
                  Refresh
                </button>
              </div>
            </div>

            <div className="divide-y divide-gray-200">
              {logs.map((log) => (
                <div key={log.id} className="p-6 hover:bg-gray-50">
                  <div className="flex items-start space-x-3">
                    <span className={`mt-0.5 flex-shrink-0 w-2 h-2 rounded-full ${
                      log.type === 'info' ? 'bg-blue-500' :
                      log.type === 'success' ? 'bg-green-500' :
                      log.type === 'warning' ? 'bg-yellow-500' :
                      'bg-red-500'
                    }`}></span>
                    <div className="flex-1">
                      <p className="text-sm text-gray-900">{log.message}</p>
                      <p className="text-xs text-gray-500 mt-1">{log.time}</p>
                    </div>
                    <span className={`px-2 py-1 rounded text-xs font-semibold ${
                      log.type === 'info' ? 'bg-blue-100 text-blue-800' :
                      log.type === 'success' ? 'bg-green-100 text-green-800' :
                      log.type === 'warning' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-red-100 text-red-800'
                    }`}>
                      {log.type.toUpperCase()}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logs;
